"use strict";

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PreviewCigarette = void 0;

var _react = _interopRequireWildcard(require("react"));

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _search = require("../../../../constants/search");

var _userflow = require("../../../../icons-react/userflow");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var DEFAULT_PLACEHOLDER = 'Страна, город или отель';

var PreviewCigarette = function PreviewCigarette(_ref) {
  var destinationName = _ref.destinationName,
      startDate = _ref.startDate,
      endDate = _ref.endDate,
      personsCount = _ref.personsCount,
      onClick = _ref.onClick,
      _ref$isMobile = _ref.isMobile,
      isMobile = _ref$isMobile === void 0 ? false : _ref$isMobile,
      className = _ref.className,
      searchType = _ref.searchType;
  var viewCondition = (0, _react.useMemo)(function () {
    return destinationName && startDate && endDate && personsCount;
  }, [destinationName, startDate, endDate, personsCount]);
  return /*#__PURE__*/_react["default"].createElement(Wrapper, {
    onClick: onClick,
    $isMobile: isMobile,
    className: className,
    $searchType: searchType,
    $firstTabOpen: searchType === _search.SEARCH_TYPE_NAMES.PACKAGE
  }, !isMobile && /*#__PURE__*/_react["default"].createElement(SearchIcon, null), !viewCondition && /*#__PURE__*/_react["default"].createElement(Item, null, DEFAULT_PLACEHOLDER), viewCondition && /*#__PURE__*/_react["default"].createElement(ItemsList, {
    $isMobile: isMobile
  }, /*#__PURE__*/_react["default"].createElement(Row, {
    $isMobile: isMobile
  }, /*#__PURE__*/_react["default"].createElement(Item, null, destinationName)), /*#__PURE__*/_react["default"].createElement(Row, {
    $isMobile: isMobile
  }, /*#__PURE__*/_react["default"].createElement(Item, null, /*#__PURE__*/_react["default"].createElement("span", null, startDate), "\u2013", /*#__PURE__*/_react["default"].createElement("span", null, endDate)), isMobile && /*#__PURE__*/_react["default"].createElement("span", null, "\u2022"), /*#__PURE__*/_react["default"].createElement(Item, null, !isMobile && /*#__PURE__*/_react["default"].createElement(_userflow.Adult, {
    height: 16
  }), /*#__PURE__*/_react["default"].createElement("span", null, personsCount, " \u0447\u0435\u043B")))));
};

exports.PreviewCigarette = PreviewCigarette;

var Wrapper = _styledComponents["default"].div.withConfig({
  displayName: "PreviewCigarette__Wrapper",
  componentId: "sc-6484sw-0"
})(["display:flex;flex:1;align-items:center;padding:8px;background:linear-gradient(270deg,#17181a 0%,#545454 100%);border-radius:", ";color:#919499;font-size:14px;line-height:16px;cursor:pointer;", ""], function (_ref2) {
  var $firstTabOpen = _ref2.$firstTabOpen,
      $isMobile = _ref2.$isMobile;

  if ($firstTabOpen) {
    return $isMobile ? '0 8px 8px 8px' : '0 4px 4px 4px';
  }

  return $isMobile ? '8px' : '4px';
}, function (_ref3) {
  var $isMobile = _ref3.$isMobile;
  return $isMobile && (0, _styledComponents.css)(["flex-wrap:wrap;height:40px;padding:4px;justify-content:center;gap:0 8px;overflow:hidden;& > ", ":first-child{flex:0 1 100%;}"], Item);
});

var Row = _styledComponents["default"].div.withConfig({
  displayName: "PreviewCigarette__Row",
  componentId: "sc-6484sw-1"
})(["display:flex;& > * + *{margin-left:", "px;}", ""], function (_ref4) {
  var $isMobile = _ref4.$isMobile;
  return $isMobile ? '8' : '16';
}, function (_ref5) {
  var $isMobile = _ref5.$isMobile;
  return $isMobile && 'justify-content: center;';
});

var Item = _styledComponents["default"].div.withConfig({
  displayName: "PreviewCigarette__Item",
  componentId: "sc-6484sw-2"
})(["display:flex;gap:4px;justify-content:center;"]);

var ItemsList = _styledComponents["default"].div.withConfig({
  displayName: "PreviewCigarette__ItemsList",
  componentId: "sc-6484sw-3"
})(["display:flex;", ";", ""], function (_ref6) {
  var $isMobile = _ref6.$isMobile;
  return !$isMobile && (0, _styledComponents.css)(["> * + *{margin-left:16px;}"]);
}, function (_ref7) {
  var $isMobile = _ref7.$isMobile;
  return $isMobile && "flex-direction: column;";
});

var SearchIcon = (0, _styledComponents["default"])(_userflow.Search).withConfig({
  displayName: "PreviewCigarette__SearchIcon",
  componentId: "sc-6484sw-4"
})(["width:24px;height:24px;stroke:#919499;margin-right:6px;"]);